import { render, staticRenderFns } from "./AthleteSelfAssessmentIntro.vue?vue&type=template&id=a8183140&scoped=true&"
import script from "./AthleteSelfAssessmentIntro.vue?vue&type=script&lang=ts&"
export * from "./AthleteSelfAssessmentIntro.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteSelfAssessmentIntro.vue?vue&type=style&index=0&id=a8183140&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8183140",
  null
  
)

export default component.exports